Immutable = require 'seamless-immutable'
{
	ACCEPT_CHANGE_REQUEST
	CANCEL_CHANGE_REQUEST
	HISTORY_CHANGE_REQUEST
} = require '../actions/history'

baseState = Immutable {
	isRequestingHistoryChange: false
}

history = (state = baseState, action) ->
	switch action.type
		when ACCEPT_CHANGE_REQUEST
			state = state.set 'isRequestingHistoryChange', false
		when HISTORY_CHANGE_REQUEST
			state = state.set 'isRequestingHistoryChange', true
		when CANCEL_CHANGE_REQUEST
			state = state.set 'isRequestingHistoryChange', false
	state

module.exports = history



// WEBPACK FOOTER //
// ./frontend/olos/js/reducers/history.coffee